/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { ApiStatus } from '@ibm-watson/shared/ts';
import { RootState } from '@ibm-watson/shared/ts/state';

export const selectSegmentKeyValue = (state: RootState): string =>
  state.integrations?.segment?.value;

export const selectIsSegmentKeyValid = (state: RootState): boolean =>
  state.integrations?.segment?.valid;

export const selectSegmentTokenUrl = (state: RootState): string =>
  state.integrations?.segment?.url;

export const selectGenerateSegmentStatus = (state: RootState): ApiStatus =>
  state.integrations?.segment?.generateStatus;
